import React from 'react'

import { useSelector } from 'react-redux'

import { RecipeUUID } from '@library/menu-service'
import { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { useRecipe } from 'hooks/menu-recipes/useRecipe'
import { useFetchRecipe } from 'routes/Menu/components/Detail/hooks/useFetchRecipe'
import { useScrollableBasket } from 'routes/Menu/hooks/useScrollableBasket'
import { getBasketDate, getBasketMenuUuid, getNumPortions } from 'selectors/basket'

import { DetailContent } from '../../Detail/DetailContent'

interface RecipeDetailProps {
  onClose: () => void
  recipeId: RecipeUUID
}

export const RecipeDetail = ({ onClose, recipeId }: RecipeDetailProps) => {
  const deliveryDate = useSelector(getBasketDate)
  const menuId = useSelector(getBasketMenuUuid)
  const numPortions = useSelector(getNumPortions)
  const menuRecipe = useRecipe(recipeId)
  const isScrollableBasketEnabled = useScrollableBasket()

  const { loading, recipe, error, reload } = useFetchRecipe(
    menuId,
    recipeId,
    numPortions,
    deliveryDate,
  )

  if (!menuRecipe?.coreId) {
    return null
  }

  return (
    <DetailContent
      uuid={menuRecipe.id}
      coreId={menuRecipe.coreId}
      title={menuRecipe.name}
      loading={loading}
      error={error}
      recipe={recipe as MenuRecipe}
      reload={reload}
      onClose={onClose}
      isScrollableBasketEnabled={isScrollableBasketEnabled}
    />
  )
}
